<template>
  <not-found-view />
</template>

<script>
/*notFound view wrapper*/

// components
import notFoundView from '../../views/notFound/NotFound';

export default {
  name: "notFound",
  components: {
    notFoundView,
  }
}
</script>

